import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
            <div class="heading01 type01">
                <h1>{{ 'budget.Budget' | translate }}</h1>
                <ul class="actions01">
                    <li ng-if="vm.PrivilegeService.canManageBudget()">
                        <a class="btn add" ng-click="vm.addEditBudgetRule()">{{ 'budget.Add budget rule' | translate }}</a>
                    </li>
                </ul>
            </div>
            <div class="nav01">
                <a ng-click="vm.decreaseYearValue()" class="btn ico-arrow-left">{{ 'budget.Previous' | translate }}</a>
                    <h2>{{ vm.filter.year }}</h2>
                <a ng-click="vm.increaseYearValue()" class="btn ico-arrow-right">{{ 'budget.Next' | translate }}</a>
            </div>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div ng-repeat="classifierBudget in vm.list.items"
                 ng-if="!vm.list.loading && vm.list.items.length"
                 class="block02"
                 ng-class="{ open: classifierBudget === vm.selectedClassifierBudget }"
            >
                <div class="heading01">
                    <h2 class="h3" ng-click="vm.openCloseAccordion(classifierBudget)">
                        {{ classifierBudget.department.value }}
                        <small>
                            {{ classifierBudget.budgetReserved ? classifierBudget.budgetReserved : 0 }} € {{ 'budget.planned' | translate }}/
                            {{ classifierBudget.budgetUsed ? classifierBudget.budgetUsed : 0 }} € {{ 'budget.used' | translate }}/
                            {{ classifierBudget.budgetSum }} € {{ 'budget.Total' | translate }}
                        </small>
                    </h2>
                    <ul class="actions01">
                        <li ng-if="vm.PrivilegeService.canManageBudget()">
                            <a class="btn edit" ng-click="vm.addEditBudgetRule(classifierBudget)">{{ 'budget.Edit budget' | translate }}</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div ng-if="vm.selectedClassifierBudget === classifierBudget" class="block03">
                        <div class="heading01">
                            <h3>{{ 'budget.Employees' | translate }}</h3>
                        </div>
                        <table class="data01" datatable dt-options="vm.DATATABLES">
                            <colgroup>
                                <col width="65%"/>
                                <col width="15%"/>
                                <col width="15%"/>
                                <col width="5%"/>
                            </colgroup>
                        <thead>
                            <tr>
                                <th>{{ 'employee.Name' | translate }}</th>
                                <th>{{ 'employee.Budget' | translate }}</th>
                                <th>{{ 'employee.Planned' | translate }}</th>
                                <th>{{ 'employee.Spent' | translate }}</th>
                                <th class="actions">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="employeeDepartmentBudget in classifierBudget.employeeDepartmentBudgets">
                                <td>{{ employeeDepartmentBudget.user.displayName }}</td>
                                <td>{{ employeeDepartmentBudget.budgetSum }} €</td>
                                <td>{{ employeeDepartmentBudget.budgetReserved ? employeeDepartmentBudget.budgetReserved : 0 }} €</td>
                                <td>{{ employeeDepartmentBudget.budgetUsed ? employeeDepartmentBudget.budgetUsed : 0 }} €</td>
                                <td class="actions">
                                    <a ng-if="vm.PrivilegeService.canManageBudget()" ng-click="vm.addEditBudgetRule(employeeDepartmentBudget)" class="btn edit">
                                        {{ 'general.Edit' | translate }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
    `
})
export default class {
    constructor (moment, lodash, DATATABLES, ListFactory, ClassifierBudgetResource, ModalService, PrivilegeService, CLASSIFIER_ENUM) {
        this.moment = moment;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.ClassifierBudgetResource = ClassifierBudgetResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
    }

    $onInit () {
        this.filter = {};
        this.filter.year = parseInt(this.moment().format('YYYY'), 10);

        this.selectedClassifierBudget = null;

        this.defaultFilter = {
            expand: 'department,employeeDepartmentBudgets.user',
            periodStartDate: this.moment().startOf('year').format('YYYY-MM-DD'),
            periodEndDate: this.moment().endOf('year').format('YYYY-MM-DD')
        };

        this.list = this.ListFactory.createWithoutPagination(this.ClassifierBudgetResource.query.bind(this.ClassifierBudgetResource));
        this.list.fetch(this.defaultFilter);
    }

    openCloseAccordion (classifierBudget) {
        if (this.selectedClassifierBudget === classifierBudget) {
            this.selectedClassifierBudget = null;
        }
        else {
            this.selectedClassifierBudget = classifierBudget;
        }
    }

    decreaseYearValue () {
        this.filter.year -= 1;
        this.fetchDataAfterYearChange();
    }

    increaseYearValue () {
        this.filter.year += 1;
        this.fetchDataAfterYearChange();
    }

    fetchDataAfterYearChange () {
        this.list.fetch(this.lodash.assign({}, this.defaultFilter, {
            periodStartDate: this.moment(`${this.filter.year}-01-01`).startOf('year').format('YYYY-MM-DD'),
            periodEndDate: this.moment(`${this.filter.year}-01-01`).endOf('year').format('YYYY-MM-DD')
        }));
    }

    addEditBudgetRule (budget = null) {
        const { list, defaultFilter } = this;
        return this.ModalService.open({
            template: '<modals-user-budget budget="vm.budget" class="wrapper" cancel="vm.$uibModalInstance.close()" on-update="vm.update()"/>',
            size: 'medium',
            controller ($state, $uibModalInstance, $translate, toastr) {
                this.$uibModalInstance = $uibModalInstance;
                this.list = list;
                this.defaultFilter = defaultFilter;
                this.budget = budget;
                this.update = () => {
                    toastr.success($translate.instant('general.Changes saved'));
                    this.$uibModalInstance.close();
                    this.list.fetch(this.defaultFilter);
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/budget/list/index.js